import { FC, memo } from 'react';
import { useQueryClient } from 'react-query';
import { useGetTaskDetails, TaskCenterConstants } from '@frontend/api-task-center';
import { Missing } from '@frontend/empty-states#svg';
import { useTranslation } from '@frontend/i18n';
import { PanelHeader } from '@frontend/panel-engine';
import { SpinningLoader, Button, Text } from '@frontend/design-system';
import { useTaskCenterStore } from '../../provider';
import { TaskDetailsRenderer } from './task-details-renderer';
import { headerStyle } from './task-details.styles';

export const TaskDetails: FC = memo(() => {
  const { t } = useTranslation('task-center');
  const queryClient = useQueryClient();
  const { locationIds, taskId, setTaskMode, setSelectedTask, setTaskId, selectedTask } = useTaskCenterStore([
    'setTaskMode',
    'setSelectedTask',
    'setTaskId',
    'locationIds',
    'taskId',
    'selectedTask',
  ]);

  const { data: taskData, isLoading, isFetching, isError } = useGetTaskDetails(locationIds, taskId);

  const task = taskId && taskData?.tasks ? taskData?.tasks[0] : selectedTask;

  const onClickBack = () => {
    if (taskId) {
      queryClient.removeQueries({
        queryKey: [TaskCenterConstants.TASK_BY_ID_QUERY_KEY, taskId],
      });
      setTaskId('');
    }
    setTaskMode(null);
    setSelectedTask(null);
  };

  return (
    <>
      <span css={headerStyle}>
        <Button variant='secondary' iconName='caret-left' onClick={onClickBack} label={t('Back')} />
        <PanelHeader.Title level={3}>{t('All Tasks')}</PanelHeader.Title>
      </span>
      {(isLoading || isFetching) && <SpinningLoader css={{ margin: 'auto' }} />}
      {(isError || (!isLoading && taskData?.tasks?.length === 0)) && (
        <>
          <Missing />
          <Text weight='bold' textAlign='center' size='large'>
            {t('No task to display')}
          </Text>
        </>
      )}
      {task && <TaskDetailsRenderer task={task} />}
    </>
  );
});

TaskDetails.displayName = 'TaskDetails';
